import {ApiResult} from './api-result';
import {ApiFilter, ApiFilterDeprecated} from "@api/filter";

export interface ApiArticlePrice {
    priceGroup: string;
    customerNumber?: string;
    netPrice: number;
    netDeposit?: number;
    netFee?: number;
    fromArticleQuantity?: number;
    fromCartQuantity?: number;
    validFrom?: string;
    validTo?: string;
}

export interface ApiArticle {
    acid?: string;
    additives?: string[];
    additionalData?: string;
    alcoholicStrength?: string;
    allergenIngredients?: string[];
    articleNumber: string;
    availability?: string;
    bestPrice?: ApiArticlePrice;
    bestPrices?: ApiArticlePrice[];
    brand?: string;
    carbohydrates?: string;
    category?: string;
    caffeine?: string;
    certificates?: string;
    characteristics?: string;
    colorNuance?: string;
    conclusion?: string;
    considerQuantityInCart?: string;
    country?: string;
    dateCreated?: Date;
    description?: string;
    depositPackageType?: string;
    dietaryFibers?: string;
    disableOrder?: {
        from: string;
        to: string;
    };
    distributor?: string;
    drinkingTemperature?: string;
 /*   eanBottle?: string;
    eanPackage?: string;*/
    eans?:{
        ean: string;
        note?: string;
    }[];
    energyInKilojoule?: string;
    energyInKilokalorie?: string;
    fatRate?: string;
    flavor?: string;
    flavorDescriptionLong?: string;
    flavorDescriptionLong2?: string;
    flavorDescriptionShort?: string;
    foodDirectory?: string;
    groups: {
        groupName: string;
        group1Name?: string;
    }[];
    growerInfo?: string;
    id: string;
    images?: {
        filePath: string;
        thumbnails: {
            small: string;
            medium: string;
            big: string;
        }
    }[];
    inventory?: number;
    invisible?: {
        from: string;
        to: string;
    };
    keywords?: string;
    lastUpdate?: Date;
    manufacturingLocation?: string;
    manufacturer?: string;
    manufacturerCompanyAddress?: string;
    manufacturerInternetAddress?: string;
    minimumDurability?: string;
    name: string;
    natrium?: string;
    notifications?: {
        category: string;
        from: string;
        to: string;
    }[];
    offerPrices: any;
    packageType?: string;
    prices: ApiArticlePrice[];
    priceChanges: {
        priceGroup: string;
        netPrice: number;
        articleFromQuantity: number;
        validFrom: string;
    }[];
    protein?: string;
    quantity: number;
    quantityAddition?: string;
    quality?: string;
    recommendation?: string;
    recommendationFilter?: string;
    relatedArticleGroup?: string;
    relatedArticleGroupPos?: number;
    region?: string;
    residualSugar?: string;
    salesDescription?: string;
    salt?: string;
    saturatedFattyAcids?: string;
    scent?: string;
    SEO?: {
        title: string;
        description: string;
        keywords: string;
    };
    shelfLife?: string;
    soilType?: string;
    sugar?: string;
    taxRate: number;
    totalWeightInKg?: number;
    unit: number;
    unitAddition?: string;
    unitOfMeasurement?: string;
    unitType?: string;
    variety?: string;
    visibilityGroups?: string[];
    vinification?: string;
    winery?: string;
    wineType?: string;
    wineTypeFilter?: string;
}

export interface ApiArticlesGetExpectedData {
    id?: 1;
    articleNumber?: 1;
    name?: 1;
    images?: 1;
    quantity?: 1;
    unit?: 1;
    taxRate?: 1;
    groups?: 1;
    prices?: 1;
    bestPrice?: 1;
    bestPrices?: 1;
    priceChanges?: 1;
    inventory?: 1;
    availability?: 1;
    packageType?: 1;
    depositPackageType?: 1;
    quantityAddition?: 1;
    unitOfMeasurement?: 1;
    unitAddition?: 1;
    unitType?: 1;
    totalWeightInKg?: 1;
    brand?: 1;
    manufacturer?: 1;
    manufacturerCompanyAddress?: 1;
    manufacturerInternetAddress?: 1;
    distributor?: 1;
    description?: 1;
    eans?: 1;
    additionalData?: 1;
    region?: 1;
    country?: 1;
    relatedArticleGroup?: 1;
    relatedArticleGroupPos?: 1;
    minimumDurability?: 1;
    salesDescription?: 1;
    manufacturingLocation?: 1;
    certificates?: 1;
    alcoholicStrength?: 1;
    caffeine?: 1;
    foodDirectory?: 1;
    additives?: 1;
    allergenIngredients?: 1;
    energyInKilojoule?: 1;
    energyInKilokalorie?: 1;
    protein?: 1;
    carbohydrates?: 1;
    fatRate?: 1;
    sugar?: 1;
    saturatedFattyAcids?: 1;
    dietaryFibers?: 1;
    natrium?: 1;
    salt?: 1;
    category?: 1;
    variety?: 1;
    flavor?: 1;
    quality?: 1;
    colorNuance?: 1;
    drinkingTemperature?: 1;
    acid?: 1;
    shelfLife?: 1;
    recommendation?: 1;
    recommendationFilter?: 1;
    characteristics?: 1;
    soilType?: 1;
    vinification?: 1;
    scent?: 1;
    vitamins?: 1;
    residualSugar?: 1;
    flavorDescriptionShort?: 1;
    flavorDescriptionLong?: 1;
    flavorDescriptionLong2?: 1;
    conclusion?: 1;
    growerInfo?: 1;
    wineDescription?: 1;
    wineType?: 1;
    considerQuantityInCart?: 1;
    visibilityGroups?: 1;
    disableOrder?: 1;
    invisible?: 1;
    notifications?: 1;
    dateCreated?: 1;
    lastUpdate?: 1;
    SEO?: 1;
}

export interface ApiArticlesGetGroupByResponse {
    count: {
        total: number;
        filtered: number;
    };
    data?: {
        value: string;
        countArticles: number;
    }[];
}

export interface ApiArticlesSetRequest {
    id: string;
    command: 'articles/set';
    params: {
        data: Omit<ApiArticle, 'bestPrice'>;
    };
}

export interface ApiArticlesGetAllowedValues {
    filterFields: 'id' | 'articleNumber' | 'partOfArticleNumber' | 'name' | 'eanPackage' | 'eanBottle' | 'description' | 'salesDescription' | 'flavor' | 'quality' | 'keywords' | 'colorNuance' | 'recommendation' | 'recommendationFilter' | 'characteristics' | 'soilType' | 'scent' | 'flavorDescriptionShort' |
        'flavorDescriptionLong' | 'conclusion' | 'growerInfo' | 'wineDescription' | 'additionalData' | 'groups.groupName' | 'groups.group1Name' | 'notifications.category' | 'quantity' | 'unit' | 'availability' | 'inventory' | 'packageType' | 'unitAddition' | 'depositPackageType' | 'unitOfMeasurement' | 'brand' |
        'manufacturer' | 'distributor' | 'country' | 'region' | 'relatedArticleGroup' | 'manufacturingLocation' | 'certificates' | 'alcoholicStrength' | 'caffeine' | 'additives' | 'allergenIngredients' | 'category' | 'vinification' | 'variety' | 'visibilityGroups',
    sortFields: 'additives' | 'alcoholicStrength' | 'allergenIngredients' | 'articleNumber' | 'availability' | 'brand' | 'caffeine' | 'category' | 'certificates' | 'country' | 'dateCreated' | 'depositPackageType' | 'distributor' | 'groups.group1Name' | 'groups.groupName' | 'inventory' | 'lastUpdate' | 'manufacturer' | 'manufacturingLocation' | 'name' | 'notifications.category' | 'partOfArticleNumber' | 'packageType' | 'quantity' | 'recommendationFilter' | 'region' | 'relatedArticleGroupPos' | 'unit' | 'unitAddition' | 'unitOfMeasurement' | 'variety';
    filterGroups: 'groups' | 'groups1' | 'availabilities' | 'packageTypes' | 'brands' | 'manufacturer' | 'distributors' | 'countries' |
        'regions' | 'manufacturingLocations' | 'recommendationsFilter' | 'notifications';
}

export class ApiArticlesGetRequestParams {
    customerId?: string;
    deliveryDate?: string;
    priceGroups?: string[];
    filters?:


        ApiFilter<ApiArticlesGetAllowedValues['filterFields']>[]


    ;
    filterNumbers?: {
        fields?: ['inventory'];
        greaterThan?: number;
        lessThan?: number;
    }[];
    filterDates?: {
        fields?: ['notifications.validFrom' | 'notifications.validTo'];
        greaterThan?: string;
        greaterThanEqual?: string;
        lessThan?: string;
        lessThanEqual?: string;
    }[];
    filterDatesArticlePrices?: {
        fields?: ['validFrom' | 'validTo'];
        greaterThan?: string;
        greaterThanEqual?: string;
        lessThan?: string;
        lessThanEqual?: string;
    }[];
    articles?: {
        start?: number;
        limit?: number;
        groupBy?: {
            field: 'relatedArticleGroup'
        };
        sortByPassedArticleNumbers?: string[];
        sortIndividual?: string;
        sortArticlePrice?: {
            direction: number;
            fromArticleQuantity: number;
            fromCartQuantity: number;
        };
        sort?: {
            field: ApiArticlesGetAllowedValues['sortFields'];
            direction: 1 | -1;
        }[];
        expectedData?: ApiArticlesGetExpectedData;
    };
    groups?: {
        searchString?: string;
        sortIndividual?: string;
    };
    groups1?: {
        searchString?: string;
        sortIndividual?: string;
    };
    availabilities?: {
        searchString?: string;
        sortIndividual?: string;
    };
    inventories?: {
        searchString?: string;
        sortIndividual?: string;
    };
    packageTypes?: {
        searchString?: string;
        sortIndividual?: string;
    };
    brands?: {
        searchString?: string;
        sortIndividual?: string;
    };
    manufacturer?: {
        searchString?: string;
        sortIndividual?: string;
    };
    distributors?: {
        searchString?: string;
        sortIndividual?: string;
    };
    countries?: {
        searchString?: string;
        sortIndividual?: string;
    };
    regions?: {
        searchString?: string;
        sortIndividual?: string;
    };
    manufacturingLocations?: {
        searchString?: string;
        sortIndividual?: string;
    };
    recommendationsFilter?: {
        searchString?: string;
        sortIndividual?: string;
    };
    priceChanges?: {};
    notifications?: {
        searchString?: string;
        sortIndividual?: string;
    };

    constructor(data?: ApiArticlesGetRequestParams) {
        Object.assign(this, data);
    }
}


export class ApiArticlesGetRequestParamsFactory {
    static create(data?: ApiArticlesGetRequestParams): ApiArticlesGetRequestParams {
        return new ApiArticlesGetRequestParams(
            data
        );
    }
}

export interface ApiArticlesGetRequest {
    id: string;
    command: 'articles/get';
    params: ApiArticlesGetRequestParams;
}

export interface ApiArticlesUpdateRequest {
    id: string;
    command: 'articles/update';
    params: {
        data: Partial<Omit<ApiArticle, 'bestPrice'>> & { id: string };
        unset?: ['invisible', 'disableOrder']
    };
}

export interface ApiArticlesDeleteRequest {
    id: string;
    command: 'articles/delete';
    params: {
        data: {
            articleNumber: string;
        };
    };
}

export interface ApiArticlesSetResponse extends ApiResult<{
    data: {
        id: string;
    }
}> {
}

export interface ApiArticlesGetResponse extends ApiResult<{
    groups?: ApiArticlesGetGroupByResponse;
    groups1?: ApiArticlesGetGroupByResponse;
    units?: ApiArticlesGetGroupByResponse;
    availabilities?: ApiArticlesGetGroupByResponse;
    inventories?: {
        count: {
            total: number;
            filtered: number;
        }
        data?: {
            value: number;
            countArticles: number;
        }[]
    };
    packageTypes?: ApiArticlesGetGroupByResponse;
    brands?: ApiArticlesGetGroupByResponse;
    manufacturer?: ApiArticlesGetGroupByResponse;
    distributors?: ApiArticlesGetGroupByResponse;
    countries?: ApiArticlesGetGroupByResponse;
    regions?: ApiArticlesGetGroupByResponse;
    manufacturingLocations?: ApiArticlesGetGroupByResponse;
    flavors?: ApiArticlesGetGroupByResponse;
    recommendationsFilter?: ApiArticlesGetGroupByResponse;
    notifications?: ApiArticlesGetGroupByResponse;
    priceChanges?: {
        data?: {
            articleNumber: string
        }[]
    }
    articles?: {
        count: {
            total: number;
            filtered: number;
        };
        data: ApiArticle[];
    };
}> {
}

export interface ApiArticlesUpdateResponse extends ApiResult<{
    articles: {
        matched: number,
        upserted: number,
        modified: number
    }
}> {
}

export interface ApiArticlesDeleteResponse extends ApiResult<{
    articles: {
        deleted: number
    }
}> {
}



